import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: 'I lost 18 pounds in 6 weeks! My belly fat is finally going away. I wish I had found this sooner.',
    author: 'Sarah M., 52'
  }, {
    quote: 'After trying everything for years, CitrusBurn finally worked for me. My energy is back and I feel 10 years younger!',
    author: 'Linda K., 47'
  }, {
    quote: "My doctor noticed the difference. I've lost 24 pounds and my metabolism feels completely reset.",
    author: 'Patricia R., 61'
  }];
  return <section className="py-16 lg:py-24 bg-white" data-id="element-76">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-77">
        <div className="text-center mb-16" data-id="element-78">
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900" data-id="element-79">
            Real Women, Real Results
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-80">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-2xl p-8 border-2 border-[#E8441A]/20 shadow-lg relative" data-id="element-81">
              <div className="flex gap-1 mb-6" data-id="element-82">
                {[...Array(5)].map((_, i) => <Star key={i} size={20} className="fill-[#E8441A] text-[#E8441A]" data-id="element-83" />)}
              </div>
              <p className="text-lg text-slate-700 italic mb-6 leading-relaxed" data-id="element-84">
                "{testimonial.quote}"
              </p>
              <p className="font-bold text-slate-900" data-id="element-85">— {testimonial.author}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}